import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { ApplicationState } from '../reducers';
import MarketingCopyContainer from '../containers/media_and_marketing_copy/MarketingCopyContainer';
import DigitalAssetsParentContainer from '../containers/media_and_marketing_copy/DigitalAssetsParentContainer';
import InsightsContainer from '../containers/insights/InsightsContainer';
import RetoolContainer from '../containers/retool/RetoolContainer';
import CustomAppContainer from '../containers/customApps/CustomAppContainer';
import ChangeLogsContainer from '../containers/change_logs/ChangeLogsContainer';

const CompanyRoutes = () => {
  const { fetchingAccDefaultValues } = useSelector((state: ApplicationState) => {
    return {
      fetchingAccDefaultValues: state.parent.accountDefaultValues.fetchingAccDefaultValues,
    };
  });

  return (
    <Routes>
      <Route path="marketing-copy" element={<MarketingCopyContainer />} />
      <Route path="digital-assets" element={<DigitalAssetsParentContainer />} />
      <Route path="insights" element={<InsightsContainer />} />
      <Route path="change-logs" element={<ChangeLogsContainer />} />
      <Route
        path="retool"
        element={
          fetchingAccDefaultValues ? (
            <Spin className="spinner-center" style={{ marginTop: '100px' }} />
          ) : (
            <RetoolContainer />
          )
        }
      />
      <Route
        path="custom-app/:appId"
        element={
          fetchingAccDefaultValues ? (
            <Spin className="spinner-center" style={{ marginTop: '100px' }} />
          ) : (
            <CustomAppContainer />
          )
        }
      />
    </Routes>
  );
};

export default CompanyRoutes;
